// extracted by mini-css-extract-plugin
export var rssCategories = "rss-parser-module--rss-categories--7f932";
export var rssContent = "rss-parser-module--rss-content--50af7";
export var rssImage = "rss-parser-module--rss-image--c7842";
export var rssTitle = "rss-parser-module--rss-title--8de05";